import styled from "@emotion/styled";
import { AppBar, Button, Tab } from "@material-ui/core";
import { units } from "../../../../types/units";

export const StyledAppBar = styled(AppBar)`
  border-bottom: 1px solid #e9e9e9;
  box-shadow: none;
  min-width: 300px;
  padding: 0;
  position: relative;
  ${units({
    color: "black",
    fontSize: "16px",
    backgroundColor: "white",
  })};

  .MuiTabs-flexContainer {
    padding: 0 2rem;
  }
  .MuiTab-root {
    margin-right: 2rem;
    min-width: 0;
    padding: 0;
  }
`;

export const StyledTab = styled(Tab)`
  font-weight: ${(props) =>
    props.selected ? props.theme.fontWeights.bold : props.theme.fontWeights.normal};
  font-size: ${(props) => props.theme.fontSizes.body};
  padding: 2rem;
`;

export const NotificationsHeader = styled.div`
  padding: 1rem 0.5rem 1rem 2rem;
  display: flex;
  justify-content: space-between;
`;

export const LinkButton = styled(Button)`
  font-size: ${(props) => props.theme.fontSizes.body};
  padding: 0.5rem;
  position: absolute;
  right: 1.5rem;
  bottom: 0.5rem;
  ${units({
    color: "grey",
  })};
`;

export const NotificationsWrapper = styled.div`
  width: 300px;
`;
